module.exports = __webpack_public_path__ + "img/15.a51f4cfd.jpg";